<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title mode="ios">
      <div  (click)="goHome()" class="header-logo">&nbsp;</div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="showMenu()" class="menu" [attr.aria-label]="'ARIA.MENU.BUTTON.LABEL_0' | translate">
        <ion-icon slot="icon-only" aria-hidden="true"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="page-title" translate>CONTENT.TITLE</div>

  <div class="content-title">{{getTranslated(userContent?.contentFull?.title)}}</div>
</ion-header>

<ion-content no-bounce>
  <div class="back-panel"></div>
  <div class="buffer"></div>
  <ng-template [ngIf]="isLoading">
    <div class="v-box full-width full-height justify-around align-center">
      <ion-spinner color="dark"></ion-spinner>
    </div>
  </ng-template>
  <ng-template [ngIf]="!isLoading && userContent !== undefined">
    <div *ngFor="let dialog of userContent.dialogs; let i = index; trackBy: trackDialog" class="dialog-area" >
      <div class="dialog-background"></div>
      <rich-text [text]="getTranslated(dialog.description)">
        <div class="dia-title" [innerHTML]="getTranslated(dialog.title)"></div>
      </rich-text>

      <div class="answer-area">
        <div class="answer-area-background"></div>
        <div class="dialog-answer hist" *ngFor="let question of dialog.questions; let j = index; trackBy: trackQuestion">

          <div class="question-text">{{getTranslated(question.text)}}</div>

          <scale-question *ngIf="question.answerType === '1'" [value]="question.response" [valueOnly]="true" [minLabel]="getMinLabel(question)" [maxLabel]="getMaxLabel(question)"
            class="content-response"></scale-question>
          <likert-question *ngIf="question.answerType === '2'" [value]="question.response" [valueOnly]="true" [minLabel]="getMinLabel(question)" [maxLabel]="getMaxLabel(question)"
            class="content-response"></likert-question>
          <yes-no-question *ngIf="question.answerType === '3'" [value]="question.response" [valueOnly]="true"
            class="content-response"></yes-no-question>
          <text-question *ngIf="question.answerType === '4'" [value]="question.response" [valueOnly]="true"
            class="content-response"></text-question>
          <mc-question *ngIf="question.answerType === '5'" [value]="question.response" [valueOnly]="true" [options]="question.options"
            class="content-response" [solution]="question.solution"></mc-question>
          <download-cert-question *ngIf="question.answerType === '6'" (valueChange)="getPdf()"
            class="content-response"></download-cert-question>
        </div>
      </div>

    </div>
    <div *ngIf="devInfo != ''" class="dev-info">
      Test-Mode: {{devInfo}}
    </div>
    <div *ngIf="dialog !== undefined" class="dialog-area" id="curDialog">
      <div class="dialog-background"></div>
      <rich-text [text]="getTranslated(dialog.description)">
        <div class="dia-title" [innerHTML]="getTranslated(dialog.title)"></div>
      </rich-text>

      <div class="answer-area">
        <div *ngFor="let item of dialog.questions; let i = index; trackBy: trackQuestion" id="answer-cur-{{i}}" [ngClass]="'dialog-answer' + ((i == markedAnswerCur) ? ' marked' : '')">
  
          <ng-template [ngIf]="item.answerType === '1'">
            <scale-question (valueChange)="answerChanged(item._id, $event)" [title]="getQuestionTitle(item)" [minLabel]="getMinLabel(item)" [maxLabel]="getMaxLabel(item)"></scale-question>
          </ng-template>
          <ng-template [ngIf]="item.answerType === '2'">
            <likert-question (valueChange)="answerChanged(item._id, $event)" [title]="getQuestionTitle(item)" [minLabel]="getMinLabel(item)" [maxLabel]="getMaxLabel(item)"></likert-question>
          </ng-template>
          <ng-template [ngIf]="item.answerType === '3'">
            <yes-no-question (valueChange)="answerChanged(item._id, $event)" [title]="getQuestionTitle(item)"></yes-no-question>
          </ng-template>
          <ng-template [ngIf]="item.answerType === '4'">
            <text-question (valueChange)="answerChanged(item._id, $event)" [title]="getQuestionTitle(item)"></text-question>
          </ng-template>
          <ng-template [ngIf]="item.answerType === '5'">
            <mc-question (valueChange)="answerChanged(item._id, $event)" [title]="getQuestionTitle(item)" 
              [options]="item.options" [solution]="item.solution"></mc-question>
          </ng-template>
          
        </div>
      </div>
      <ion-grid>
        <ion-row>
          <ion-col size="6">
            <ion-button fill="solid" shape="round" expand="block" color="light" (click)="onCancelClick()">
              <div translate>COMMON.CANCEL</div>
            </ion-button>
          </ion-col>
          <ion-col size="6" (click)="scrollToInvalid()">
            <ion-button fill="solid" shape="round" expand="block" [disabled]="!isValid" (click)="onNextClick()">
              <div translate>COMMON.OK</div>
            </ion-button>
          </ion-col>
        </ion-row>        
      </ion-grid>
    </div>
    <div *ngIf="footerInfo != ''" class="footer-info" id="footer">
      <div class="footer-background"></div>
      <div class="footer-info-content">
        {{footerInfo}}
        <ion-grid *ngIf="canProceed">
          <ion-row>
            <ion-col size="6">
              <ion-button fill="solid" shape="round" expand="block" color="light" (click)="onGoOnClick()">
                <div translate>CONTENT.FLOW.RETURN</div>
              </ion-button>
            </ion-col>
            <ion-col size="6">
              <ion-button fill="solid" shape="round" expand="block" color="light" (click)="onProceedClick()">
                <div translate>CONTENT.FLOW.PROCEED</div>
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>  
        <ion-button *ngIf="justAnswered && !canProceed" fill="solid" shape="round" expand="block" color="light" (click)="onGoOnClick()">
          <div translate>CONTENT.FLOW.GO_ON</div>
        </ion-button>
      </div>  
    </div>
  
  </ng-template>
</ion-content>
<ion-footer>
  <content-diagram [value]="diagramValue" [total]="diagramTotal"></content-diagram>
</ion-footer>
